/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EligibilityCheck } from './EligibilityCheck';
import {
    EligibilityCheckFromJSON,
    EligibilityCheckFromJSONTyped,
    EligibilityCheckToJSON,
    EligibilityCheckToJSONTyped,
} from './EligibilityCheck';

/**
 * 
 * @export
 * @interface GetEligibilityChecks200Response
 */
export interface GetEligibilityChecks200Response {
    /**
     * 
     */
    data?: Array<EligibilityCheck>;
}

/**
 * Check if a given object implements the GetEligibilityChecks200Response interface.
 */
export function instanceOfGetEligibilityChecks200Response(value: object): value is GetEligibilityChecks200Response {
    return true;
}

export function GetEligibilityChecks200ResponseFromJSON(json: any): GetEligibilityChecks200Response {
    return GetEligibilityChecks200ResponseFromJSONTyped(json, false);
}

export function GetEligibilityChecks200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEligibilityChecks200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(EligibilityCheckFromJSON)),
    };
}

export function GetEligibilityChecks200ResponseToJSON(json: any): GetEligibilityChecks200Response {
    return GetEligibilityChecks200ResponseToJSONTyped(json, false);
}

export function GetEligibilityChecks200ResponseToJSONTyped(value?: GetEligibilityChecks200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(EligibilityCheckToJSON)),
    };
}

